import React from 'react'

import { ICustomerInfo } from 'features/Ticket'
import { ITicketSelectBranchList } from '../../TicketSelectBranch'
import { CreateTicketLabel } from '../CreateTicketLabel'
import { useTranslation } from 'react-i18next'

interface CreateTicketBrachInfoSectionProps {
  branchInfo: ITicketSelectBranchList
  isLoading: boolean
}

export const CreateTicketBrachInfoSection: React.FC<CreateTicketBrachInfoSectionProps> =
  ({ branchInfo, isLoading }) => {
    const base = 'f-ticket-branch-info'
    const { t } = useTranslation(['ticket'])

    const items = (branchInfo: ITicketSelectBranchList): ICustomerInfo[] => {
      const { branchName, companyName, phone } = branchInfo

      return [
        {
          key: 'branchName',
          title: 'ticket:branchName.title',
          value: branchName,
          skeletonWidthValue: '313px',
          skeletonWidthValueLine2: '246px',
        },
        {
          key: 'companyName',
          title: 'ticket:companyName.title',
          value: companyName,
          skeletonWidthValue: '313px',
          skeletonWidthValueLine2: '246px',
        },
        {
          key: 'phone',
          title: 'ticket:phoneNumber.title',
          value: phone,
          skeletonWidthValue: '126px',
        },
      ]
    }

    return (
      <>
        <div className={`${base}__branch-info-title`}>
          {t('ticket:customerDetail.column')}
        </div>
        <div className={base}>
          {items(branchInfo).map((item, index) => (
            <div key={`${item.key}-${index}`} className={`${base}--item`}>
              <CreateTicketLabel
                isLoading={isLoading}
                title={item.title}
                value={item.value}
                isShowSkeletonTitle
                skeletonWidthTitle='77px'
                skeletonWidthValue={item.skeletonWidthValue}
                skeletonWidthValueLine2={item.skeletonWidthValueLine2}
              />
            </div>
          ))}
        </div>
      </>
    )
  }
